<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<CvIntro></CvIntro>
	
	2019-06-08	init

-->

<template>
	<div class="CvIntro maxWidth maxWidth--page" :class="elmClasses">
		<div class="CvIntro__inner">
		
			<div class="CvIntro__header background background--white">
				<h2 class="CvIntro__headerTitle hSpace hSpace--large font XXfont--bold font--sizeBig">
					CSV-Validator
				</h2>
			</div>
			<div class="CvIntro__body background background--white hSpace hSpace--large">
				<p>
				  Mit Hilfe des CSV-Validators des Landesamtes für Denkmalpflege können Sie Ihre CSV-Listen gegen unsere Vorlagen validieren. 
				  Benutzen Sie dazu bitte die jeweils aktuellen Browserversionen von Google Chrome, 
				  Mozilla Firefox oder Microsoft Edge. Ältere Browser können unter Umständen Probleme bei der Darstellung der Inhalte haben. 
				  Eingeschaltetes JavaScript ist erforderlich.
				</p>
				
				<div v-show-slide="isTextExpanded">
					<br />
					
					<ul>
						<li>Als Feld-/Spaltentrenner ist das Semikolon (;) zu verwenden, als Dezimaltrenner (d. h. für die Trennung von Vor- und Nachkommastellen von Werten) wird der Punkt (.) verwendet.</li>
						<li>Für die korrekte Anzeige von Umlauten und gegebenenfalls Sonderzeichen achten Sie auf die Speicherung Ihrer CSV-Datei im Zeichensatzformat „UTF-8“.</li>
						<li>Dateien, die nicht korrekt in UTF-8 kodiert sind, werden nicht akzeptiert. Bitte verzichten Sie auf die Umschreibung von Umlauten.</li>
						<li>Stellen Sie bitte sicher, dass Ihre CSV-Dateien keine „Programmartefakte“ (beispielsweise Steuerzeichen aus/für Microsoft Excel) enthalten.</li>
					</ul>
					
					<br />

					<p>Zu keiner Zeit werden Ihre Daten auf unseren Servern gespeichert oder für andere Zwecke und/oder Teilnehmer zugänglich gemacht. Weitere Informationen zur Erhebung von Daten nach der Datenschutz-Grundverordnung können Sie hier entnehmen: <a href="https://rp.baden-wuerttemberg.de/Seiten/datenschutz.aspx" target="_blank">https://rp.baden-wuerttemberg.de/Seiten/datenschutz.aspx.</a></p>
					
					<br />
					
					<p>Eine kurze Anleitung zur Nutzung finden Sie hier am Fuß des linken Seitenbereichs unter „Hilfe“.</p>
				</div>
				
				<br />
				
				<a class="block" @click="isTextExpanded = !isTextExpanded">
					<template v-if="isTextExpanded">Einklappen</template>
					<template v-else>Ausklappen</template>
				</a>
			</div>
			<div class="CvIntro__footer background background--grey hSpace hSpace--large">
				<div class="grid grid--cols-4 grid--columnGap">
					
					<div class="CvIntro__footerColumn">
						<div class="flex">
							<p class="CvIntro__stepNr color color--white font font--sizeHuge">1</p>
							<p class="CvIntro__stepText font font--bold color color--white vSpace vSpace--default">CSV hochladen</p>
						</div>
						<BaseFileInput
							id="filePicker"
							accept=".csv"
							label="CSV-Datei hochladen ..."
							@change="app.onSelectFile"
						></BaseFileInput>
						<!--
						<input 
							id="filePicker" 
							type="file" 
							@change="app.onSelectFile" 
							multiple="false" 
							accept=".csv" 
						/>
						-->
						<!--<button @click="app.removeCsvFile()">Remove</button>-->
					</div>
					<div class="CvIntro__footerColumn">
						<div class="flex">
							<p class="CvIntro__stepNr color color--white font font--sizeHuge">2</p>
							<p class="CvIntro__stepText font font--bold color color--white vSpace vSpace--default">Schema wählen</p>
						</div>
						<BaseSelect
							class="CvIntro__baseSelect"
							:value="app.selectedScheme"
							:options="_.map( this.app.schemes, (k, v)=>{ return v } )"
							@change="app.selectedScheme = $event.target.value"
						></BaseSelect>	
					</div>
					<div class="CvIntro__footerColumn">
						<div class="flex">
							<p class="CvIntro__stepNr color color--white font font--sizeHuge">3</p>
							<p class="CvIntro__stepText font font--bold color color--white vSpace vSpace--default">Zeichensatz wählen</p>
						</div>
						<BaseSelect
							class="CvIntro__baseSelect"
							:value="app.currentCharset"
							:options="['UTF-8', 'iso-8859-1', 'CP1251']"							
							@change="app.currentCharset = $event.target.value"
						></BaseSelect>	
					</div>
					<div class="CvIntro__footerColumn flex flex--column flex--right">
						<div class="relative">
							<br/>
							<!--
							<button 
								:disabled="!app.isReadyToValidate" 
								@click="app.doParseCsv()">
								Validieren
							</button>
							{{app.isParsing}}
							-->
							<BaseButton
								class="BaseButton--validate"
								:disabled="!app.isReadyToValidate"
								tag="button"
								label="Validieren"
								@click.native="app.doParseCsv()"
							></BaseButton>
							<MhSpinner v-if="app.isParsing"></MhSpinner>							
						</div>
					</div>
					
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import BaseSelect from '@/components/MhForm/BaseSelect.vue'
	import BaseSelect from '@/components/MhForm/v1/BaseSelect.vue'
	import BaseButton from '@/components/MhForm/v1/BaseButton.vue'
	import BaseFileInput from '@/components/MhForm/v1/BaseFileInput.vue'
	import MhSpinner from '@/components/MhSpinner/MhSpinner.vue'

	export default {
		name: 'CvIntro',
		components: {
			BaseSelect,
			BaseButton,
			BaseFileInput,
			MhSpinner,
		},
		mixins: [],
		props: {},
		data() {
			return {
				isTextExpanded : false,				
			}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
		},
		methods: {},
		created() {
			//window.addEventListener('scroll', this.handleScroll);
		},
		mounted() {},
		destroyed () {
   			//window.removeEventListener('scroll', this.handleScroll);
 		},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvIntro {
		//outline: 1px solid green;
		
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-grow: 1;
		width: 100%;
		margin: 0 auto;
	}
	.CvIntro__inner {
		//& > * { outline: 1px solid red; }
	}
	
	.CvIntro__header {
		padding: 1.5em 0;
		
		border-bottom: 1px solid @swatches[middleGrey];
		border-top-left-radius: 0.25em;
		border-top-right-radius: 0.25em;
		
		&Title {
			opacity: 0.5;
		}
	}
	.CvIntro__body {
		padding: 1.5em 0;
		
		//border-top-left-radius: 0.25em;
		//border-top-right-radius: 0.25em;
	}
	.CvIntro__footer {
		padding: 0.5em 0;
		border-bottom-left-radius: 0.25em;
		border-bottom-right-radius: 0.25em;
		
		//&Column { outline: 1px solid red; }
		&Column { 
			padding: 1em 0;
			overflow: hidden; 
		}
		&Column + &Column {
			border-left: 1px solid fade(black, 30);
			padding-left: 1em;			
		}
		
		.MhSpinner {
			position: absolute;
			bottom: 0.5em; right: 0.5em;
			color: white;
		}
	}
	
	.CvIntro__stepNr {
		padding-right: 0.25em;
		padding-bottom: 0.35em;
		line-height: 1.1em;
	}
	/*
	.CvIntro__baseSelect {
		//background-color: transparent;
		//background-color: fade(black, 20);
		//color: fade(white, 85);
	}
	*/
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
